// @flow
import type {
  AustinUiTransition,
  BitmovinUiTransition,
  UiTransitionConfig,
  ReceiverUiTransition,
  CommonUiTransition,
} from 'Common/cast/types';

/* NOTE: src/dany-one/src/browser/cast/receiver/STATE_MACHINE_DIAGRAM.png is a
visual representation of all state machine states and transitions */
const AustinTransitions: Array<UiTransitionConfig<AustinUiTransition | CommonUiTransition>> = [
  {
    name: 'idle',
    from: ['Bitmovin_playback_finished', 'Bitmovin_error', 'Austin_error', 'Austin_disconnecting'],
    to: 'idle',
  },
  {
    name: 'requestLoad',
    from: ['idle', 'Bitmovin_playing', 'Bitmovin_paused', 'Austin_streaming'],
    to: 'loading_asset',
  },
  {
    name: 'connect',
    from: ['loading_asset', 'Austin_streaming', 'Austin_paused'],
    to: 'Austin_connecting',
  },
  { name: 'startStreaming', from: 'Austin_connecting', to: 'Austin_starting_streaming' },
  {
    name: 'stream',
    from: [
      'Austin_starting_streaming',
      'Austin_paused',
      'loading_asset',
      'Austin_changing_channel',
      'Austin_seeking',
    ],
    to: 'Austin_streaming',
  },
  { name: 'pauseAustin', from: 'Austin_streaming', to: 'Austin_paused' },
  { name: 'austinSeek', from: 'Austin_streaming', to: 'Austin_seeking' },
  {
    name: 'changeChannel',
    from: ['Austin_streaming', 'Austin_paused', 'loading_asset'],
    to: 'Austin_changing_channel',
  },
  {
    name: 'disconnect',
    from: ['Austin_streaming', 'Austin_paused', 'Austin_stopping_streaming'],
    to: 'Austin_disconnecting',
  },
  {
    name: 'austinError',
    from: [
      'Austin_connecting',
      'Austin_starting_streaming',
      'Austin_stopping_streaming',
      'Austin_streaming',
      'Austin_paused',
      'Austin_changing_channel',
      'Austin_disconnecting',
    ],
    to: 'Austin_error',
  },
  {
    name: 'stopStreaming',
    from: ['Austin_paused', 'Austin_streaming'],
    to: 'Austin_stopping_streaming',
  },
];

const BitmovinTransitions: Array<UiTransitionConfig<BitmovinUiTransition | CommonUiTransition>> = [
  {
    name: 'loadStream',
    from: ['loading_asset', 'Bitmovin_playing', 'Bitmovin_paused'],
    to: 'Bitmovin_loading_stream',
  },
  { name: 'play', from: ['Bitmovin_loading_stream', 'Bitmovin_paused'], to: 'Bitmovin_playing' },
  { name: 'pauseBitmovin', from: 'Bitmovin_playing', to: 'Bitmovin_paused' },
  {
    name: 'playbackFinished',
    from: ['Bitmovin_playing', 'Bitmovin_paused'],
    to: 'Bitmovin_playback_finished',
  },
  {
    name: 'bitmovinError',
    from: ['Bitmovin_loading_stream', 'Bitmovin_playing', 'Bitmovin_paused', 'loading_asset'],
    to: 'Bitmovin_error',
  },
];

const TRANSITIONS = [...AustinTransitions, ...BitmovinTransitions];

const STATE_TRANSITION_MAPPING: Map<string, ReceiverUiTransition> = new Map([
  ['REQUEST_LOAD', 'requestLoad'],
  ['PLAYER_LOAD_COMPLETE', 'loadStream'],

  ['ERROR', 'bitmovinError'],
  ['PLAYING', 'play'],
  ['connecting', 'connect'],
  ['disconnecting', 'disconnect'],
  ['startingStreaming', 'startStreaming'],
  ['stoppingStreaming', 'stopStreaming'],
  ['channel_change', 'changeChannel'],
  ['onError', 'austinError'],
  ['austin_pause', 'pauseAustin'],
  ['austin_play', 'stream'],
  ['streaming', 'stream'],
  ['bitmovin_play', 'play'],
  ['bitmovin_pause', 'pauseBitmovin'],
  ['seeked', 'stream'],
  ['seek', 'stream'],
  ['playbackFinished', 'playbackFinished'],
  ['austinSeek', 'austinSeek'],

  ['idle', 'idle'],
]);

export { TRANSITIONS, STATE_TRANSITION_MAPPING };
